import { Box, IconButton, Divider, Tooltip } from "@mui/material"
import PrivacyTipIcon from "@mui/icons-material/PrivacyTip"
import GavelIcon from "@mui/icons-material/Gavel"
import SettingsIcon from "@mui/icons-material/Settings"
import { useNavigate } from "react-router-dom"
import CookieIcon from "@mui/icons-material/Cookie"
import AccessibleIcon from "@mui/icons-material/Accessible"
import AccessibilityModal from "../Modals/AccessibilityModal/AccessibilityModal"
import { useRef } from "react"

export default function RightSidebar() {
  const navigate = useNavigate()
  const accessRef = useRef()

  const openAccesibilityModal = () => {
    if (accessRef.current) {
      accessRef.current.childFunction()
    }
  }

  return (
    <Box
      sx={{
        position: "fixed",
        top: 40,
        left: 0,
        width: 80,
        height: "100vh",
        bgcolor: "rgba(255, 255, 255, 0.7)", // חצי שקוף
        backdropFilter: "blur(8px)", // אפקט זכוכית
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        py: 2,
        zIndex: 0,
        borderLeft: "1px solid rgba(0,0,0,0.1)",
      }}
    >
      <AccessibilityModal ref={accessRef} />

      <Tooltip title='מדיניות פרטיות' placement='left'>
        <IconButton color='primary' onClick={() => navigate("/privacy-policy")}>
          <PrivacyTipIcon />
        </IconButton>
      </Tooltip>

      <Divider flexItem sx={{ my: 1 }} />

      <Tooltip title='תנאי שימוש' placement='left'>
        <IconButton color='secondary' onClick={() => navigate("/terms-of-service")}>
          <GavelIcon />
        </IconButton>
      </Tooltip>
      <Divider flexItem sx={{ my: 1 }} />

      <Tooltip title='עוגיות' placement='left'>
        <IconButton sx={{ color: "gold" }} onClick={() => navigate("/cookies")}>
          <CookieIcon />
        </IconButton>
      </Tooltip>
      <Divider flexItem sx={{ my: 1 }} />
      <Tooltip title='נגישות' placement='left'>
        <IconButton sx={{ color: "brown" }} onClick={() => openAccesibilityModal()}>
          <AccessibleIcon />
        </IconButton>
      </Tooltip>
      <Divider flexItem sx={{ my: 1 }} />

      <Tooltip title='הגדרות' placement='left'>
        <IconButton sx={{ color: "red" }}>
          <SettingsIcon />
        </IconButton>
      </Tooltip>
    </Box>
  )
}
